import { InjectionToken, Provider } from '@angular/core';

export const ViewBaseRoute = new InjectionToken<string>('view base route');

export const provideViewBaseRoute = (baseRoute: string): Provider => ({
  provide: ViewBaseRoute,
  useValue: baseRoute,
});
